// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 963 ? "a5464f33" : chunkId) + "." + {"101":"99f67638749b932e","963":"30d9456768b2fe92"}[chunkId] + ".js";
};